import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Input, Row, Space, theme, Table, message } from 'antd';
import LoadingBase from '../../components/LoadingBase';
import { addNewBookType, getBookTypes } from '../../services/apis';
import '../../css/listbook-page.css';
import AddDataModal from '../../components/AddDataModal';

const BookTypeCategoryPage = () => {
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const columns = [
        {
            title: 'Mã',
            dataIndex: 'id',
            key: 'id',
            width: 150,
            align: 'center',
        },
        {
            title: 'Tên loại sổ',
            dataIndex: 'type_name',
            key: 'type_name',
            render: (text) => <div style={{paddingTop: 8, paddingBottom: 8}}>{text}</div>
        },
        
    ];
    const formStyle = {
        maxWidth: 'none',
        background: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        padding: 24,
    };

    const handleAddData = async (name) => {
        if (!name || name.length === 0) {
            return;
        }
        setShowModal(false);
        const params = {
            name: name
        };
        setLoading(true);
        const res = await addNewBookType(params);
        setLoading(false);
        if (res && res.status === 1) {
            message.success("Thêm mới thành công", 5);
            getDataBookType();
        } else {
            message.error(res?.msg ?? 'Có lỗi xảy ra', 5);
        }
    }
    const handleCancel = () => {
        setShowModal(false);
    }
    const getDataBookType = async (keyword) => {
        const params = {
            name: keyword
        }
        setLoading(true);
        const res = await getBookTypes(params);
        setLoading(false);
        if (res && res?.status === 'success') {
            setData(res?.data ? [...res.data] : []);
        } else {
            setData([]);
        }
    }
    
    const onFinish = async (data) => {
        getDataBookType(data.name);
    };
    useEffect(() => {
        getDataBookType();
    }, [])
    return (
        <div className='container-content'>
            <Form form={form} name="advanced_search" style={formStyle} onFinish={onFinish}>
                <Row gutter={24}>
                    <Col span={8}>
                        <Form.Item
                            name={'name'}
                        >
                            <Input placeholder={'Tên loại sổ'} />
                        </Form.Item>
                    </Col>
                    
                    
                    <Col span={4}>
                        <Space size="small">
                            <Button type="primary" htmlType="submit">
                                Tìm kiếm
                            </Button>
                            <Button
                                onClick={() => {
                                    setShowModal(true);
                                }}
                            >
                                Thêm mới
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Form>
            <Table
                className='table-book'
                columns={columns}
                dataSource={data}
                pagination={{
                    pageSize: 20
                }}
                rowKey={(record) => record?.id}
            />
            <AddDataModal visible={showModal} onCancel={handleCancel} onSave={handleAddData} title={"Thêm mới loại sổ"}/>
            <LoadingBase loading={loading} />
        </div>

    );
};
export default BookTypeCategoryPage;